import { render } from "./widget-object-user-attributes.vue?vue&type=template&id=e2f92e8a"
import script from "./widget-object-user-attributes.vue?vue&type=script&setup=true&lang=js"
export * from "./widget-object-user-attributes.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/object/object-card/Widgets/widget-object-user-attributes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e2f92e8a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e2f92e8a', __exports__)) {
    api.reload('e2f92e8a', __exports__)
  }
  
  module.hot.accept("./widget-object-user-attributes.vue?vue&type=template&id=e2f92e8a", () => {
    api.rerender('e2f92e8a', render)
  })

}


export default __exports__